export default "__VITE_ASSET__4d587b75__"